/* script */
//
//
//
//
//

import action from './action';

/**
 * @typedef {{ label: string, name: string, value: boolean }[]} CheckboxesOptions
 */

import LeaderboardExportModal from './LeaderboardExportModal.vue';

const __vue_script__ = {
    name: 'LeaderboardExportButton',

    mixins: [action],

    data() {
        return {
            exported: false,
            exporting: false,
        };
    },

    methods: {
        /** @returns {Promise<{personFields:CheckboxesOptions,leaderboardFields:CheckboxesOptions}|undefined>} */
        async getFields() {
            const leaderboardResults = await this.$services.appScripts.callAppScript(
                this.event._id,
                'leaderboard/aggregation',
                {
                    leaderboardId: this.item._id,
                    output_format: 'json',
                });
            const firstResult = leaderboardResults?.data[0];
            if (!firstResult) {
                return undefined;
            }

            const personMetadata = await this.$services.metadata.getMetadataForType(this.event._id, 'person');
            /** @type {CheckboxesOptions} */
            const personFields = [{ name: 'fp_ext_id', label: 'fp_ext_id', value: true }];
            /** @type {CheckboxesOptions} */
            const leaderboardFields = [];
            for (const key of Object.keys(firstResult)) {
                if (key.startsWith('fp_') || key.startsWith('_')) {
                    continue;
                }
                if (personMetadata[key]) {
                    personFields.push({
                        label: personMetadata[key].label || key,
                        name: key,
                        value: true,
                    });
                } else {
                    leaderboardFields.push({
                        label: key,
                        name: key,
                        value: true,
                    });
                }
            }


            return { personFields, leaderboardFields };
        },

        noResultsDialog() {
            this.$modal.show('dialog', {
                title: this.$t('listings.messages.no_leaderboard_to_export_title'),
                text: this.$t('listings.messages.no_leaderboard_to_export_description'),
                buttons: [
                    {
                        title: this.$t('base.ok'),
                        handler: () => { this.$modal.hide('dialog'); },
                        class: 'btn',
                    },
                ],
            });
        },

        async exportLeaderboard() {
            const fields = await this.getFields();
            if (!fields) {
                return this.noResultsDialog();
            }

            this.$modal.show(LeaderboardExportModal, {
                eventId: this.event._id,
                leaderboardId: this.item._id,
                personFields: fields.personFields,
                leaderboardFields: fields.leaderboardFields,
            }, {
                height: 'auto',
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"export-button btn btn-icon single",attrs:{"disabled":_vm.exporting,"aria-label":_vm.$t('listings.messages.export')},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.exportLeaderboard.apply(null, arguments)}}},[_c('i',{staticClass:"ic-download"})])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LeaderboardExportButton.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__